var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordsearchGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2 31.288C27.7307 31.288 27.3893 31.192 27.176 31C26.984 30.808 26.8667 30.5093 26.824 30.104L26.952 28.504C26.7387 28.8453 26.408 29.24 25.96 29.688C25.512 30.1147 24.9253 30.4987 24.2 30.84C23.4747 31.16 22.5893 31.32 21.544 31.32C20.52 31.32 19.56 31.1173 18.664 30.712C17.7893 30.3067 17.0107 29.7413 16.328 29.016C15.6667 28.2907 15.144 27.4587 14.76 26.52C14.3973 25.5813 14.216 24.5787 14.216 23.512C14.216 22.4667 14.3973 21.4853 14.76 20.568C15.144 19.6293 15.6773 18.808 16.36 18.104C17.0427 17.4 17.8213 16.8453 18.696 16.44C19.592 16.0347 20.5413 15.832 21.544 15.832C22.4827 15.832 23.2827 15.96 23.944 16.216C24.6053 16.4507 25.1707 16.7707 25.64 17.176C26.1307 17.56 26.5573 17.9973 26.92 18.488L26.856 17.144C26.8347 16.6747 26.9307 16.344 27.144 16.152C27.3787 15.9387 27.7413 15.832 28.232 15.832C28.6373 15.832 28.9253 15.896 29.096 16.024C29.288 16.152 29.416 16.3333 29.48 16.568C29.544 16.8027 29.576 17.0907 29.576 17.432V29.784C29.576 30.0827 29.544 30.3493 29.48 30.584C29.416 30.8187 29.288 30.9893 29.096 31.096C28.904 31.224 28.6053 31.288 28.2 31.288ZM22.024 28.632C22.8773 28.632 23.656 28.408 24.36 27.96C25.0853 27.512 25.6507 26.9147 26.056 26.168C26.4827 25.4 26.696 24.5253 26.696 23.544C26.696 22.5413 26.472 21.6667 26.024 20.92C25.5973 20.152 25.0213 19.5547 24.296 19.128C23.592 18.68 22.8133 18.456 21.96 18.456C20.9573 18.456 20.0827 18.6907 19.336 19.16C18.6107 19.608 18.0347 20.216 17.608 20.984C17.1813 21.752 16.968 22.6267 16.968 23.608C16.968 24.568 17.1813 25.432 17.608 26.2C18.0347 26.9467 18.6213 27.544 19.368 27.992C20.136 28.4187 21.0213 28.632 22.024 28.632Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0008 39.0018C25.9793 39.0018 29.7949 37.4213 32.6081 34.6081C35.4213 31.7949 37.0018 27.9793 37.0018 24.0008C37.0018 20.0223 35.4213 16.2067 32.6081 13.3935C29.7949 10.5802 25.9793 8.99976 22.0008 8.99976C18.0223 8.99976 14.2067 10.5802 11.3935 13.3935C8.58022 16.2067 6.99976 20.0223 6.99976 24.0008C6.99976 27.9793 8.58022 31.7949 11.3935 34.6081C14.2067 37.4213 18.0223 39.0018 22.0008 39.0018ZM35.9397 35.3926L45.9994 45.4522L43.4522 47.9994L33.3926 37.9397C29.8167 40.8621 25.2545 42.2984 20.6494 41.9516C16.0443 41.6048 11.7487 39.5014 8.65083 36.0764C5.55299 32.6515 3.88996 28.1669 4.00566 23.5502C4.12135 18.9336 6.00694 14.5379 9.27244 11.2724C12.5379 8.00694 16.9336 6.12135 21.5502 6.00566C26.1669 5.88996 30.6515 7.55299 34.0764 10.6508C37.5014 13.7487 39.6048 18.0443 39.9516 22.6494C40.2984 27.2545 38.8621 31.8167 35.9397 35.3926Z",
    fill: "#5DEE7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_182",
    x: 0,
    y: 6,
    width: 49.9994,
    height: 49.9994,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_182",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordsearchGreen);
export default __webpack_public_path__ + "static/media/wordsearch-green.bbc5eb35c8423d735b56e13a0bed1c46.svg";
export { ForwardRef as ReactComponent };